import { render, staticRenderFns } from "./BeeMoneyLabel.vue?vue&type=template&id=5b9b136c"
import script from "./BeeMoneyLabel.vue?vue&type=script&lang=js"
export * from "./BeeMoneyLabel.vue?vue&type=script&lang=js"
import style0 from "./BeeMoneyLabel.vue?vue&type=style&index=0&id=5b9b136c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports